import { ref, unref, computed } from 'vue';
import type { Color } from '~/declaration/traits';
import type { Product, Image } from '~~/shared/globalTypes/product';

function getMemberProduct(product: Product, selectedLatchkey: ComputedRef<string>, latchKeyProductIdsByGroup: ComputedRef<Record<string, string[]>>) {
  const latchkeyGroup = unref(latchKeyProductIdsByGroup)[unref(selectedLatchkey)] || [];
  const latchkeyMemberProductId = latchkeyGroup.length === 1 ? latchkeyGroup[0] : '';
  return unref(product).relationships.memberProductMap[unref(latchkeyMemberProductId)];
}

export default function useImageLatchkey(
  product: Product,
  selectedColor: WritableComputedRef<Color | null>,
  selectedUpcId: ComputedRef<string | undefined>,
  selectedLatchkey: ComputedRef<string>,
  latchKeyProductIdsByGroup: ComputedRef<Record<string, string[]>>,
): ComputedRef<Image[]> {
  /** @type {Ref<Image[]>} */
  const lastValidImages = ref([]); // TODO remove this image cache once mcom xapi migrates to bcom data

  const images = computed(() => {
    let result = [];

    const latchkeyProduct = product?.relationships?.latchKeyToProductMap?.[selectedLatchkey.value];
    const upcMap = latchkeyProduct?.traits.traitsMaps?.upcMap || {};
    const selectedColorId = unref(selectedColor)?.id;
    const firstUpcKeyWithColor = Object.keys(upcMap).find((upcKey) => upcKey.includes(selectedColorId));
    const firstUpcIdWithColor = upcMap[firstUpcKeyWithColor];

    const upcIdSource = unref(selectedUpcId) || firstUpcIdWithColor;

    const upcProduct = product?.relationships.upcs[upcIdSource];
    const memberProduct = getMemberProduct(product, selectedLatchkey, latchKeyProductIdsByGroup);

    if (upcProduct) {
      result = upcProduct.imagery.images || [];
    } else if (memberProduct) {
      result =
        Object.values(unref(memberProduct).traits.colors?.colorMap || {}).find((c) => c.name === unref(selectedColor)?.name)?.imagery.images ||
        unref(memberProduct).imagery?.images ||
        product?.imagery?.images ||
        [];
    } else {
      result =
        Object.values(product?.traits?.colors?.colorMap || {}).find((c) => c.name === unref(selectedColor)?.name)?.imagery.images ||
        product?.imagery?.images ||
        [];
    }

    if (result.length) {
      lastValidImages.value = result;
      return result;
    }

    return lastValidImages.value;
  });

  return images;
}
